<template>
  <aside class="mail-card mail-preview-card">
    <div class="mail-preview-header">
      <h2>{{ tt("general.preview", "Önizleme") }}</h2>
      <div class="mail-preview-toggles">
        <button :class="{ 'is-active': previewMode === 'desktop' }" :title="tt('mail.desktop_preview', 'Masaüstü')"
          type="button" @click="$emit('update:previewMode', 'desktop')">
          <i class="uil-monitor"></i>
        </button>
        <button :class="{ 'is-active': previewMode === 'mobile' }" :title="tt('mail.mobile_preview', 'Mobil')"
          type="button" @click="$emit('update:previewMode', 'mobile')">
          <i class="uil-mobile-android"></i>
        </button>
      </div>
    </div>
    <div :class="{ 'is-mobile': previewMode === 'mobile' }" class="mail-preview-frame">
      <div class="mail-preview-canvas">
        <div class="mail-preview-body" v-html="previewHtml"></div>
        <p class="mail-preview-footer">{{ autoSentFooter }}</p>
      </div>
    </div>
  </aside>
</template>

<script>
export default {
  name: "MailTemplatePreview",
  props: {
    previewMode: {
      type: String,
      default: "desktop",
    },
    previewHtml: {
      type: String,
      default: "",
    },
    autoSentFooter: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      highlightTimer: null,
    };
  },
  methods: {
    tt(key, fallback) {
      if (this.$te && this.$te(key)) {
        const translated = this.$t(key);
        if (translated && translated !== key) return translated;
      }
      return fallback;
    },
    highlight() {
      const el = this.$el;
      if (!el || !el.scrollIntoView) return;
      el.scrollIntoView({ behavior: "smooth", block: "start" });
      el.classList.add("is-highlighted");
      clearTimeout(this.highlightTimer);
      this.highlightTimer = setTimeout(() => {
        el.classList.remove("is-highlighted");
      }, 900);
    },
  },
  beforeDestroy() {
    clearTimeout(this.highlightTimer);
  },
};
</script>

<style scoped>
.mail-card {
  background: #fff;
  border: 1px solid var(--mail-border);
  border-radius: 12px;
  padding: 20px 24px 24px;
}

.mail-preview-card {
  position: sticky;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  padding: 20px 24px 28px;
  transition: box-shadow 0.25s ease;
}

.mail-preview-card.is-highlighted {
  box-shadow: 0 0 0 3px rgba(91, 79, 255, 0.12);
}

.mail-preview-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 22px;
}

.mail-preview-header h2 {
  margin: 0;
  color: var(--mail-text);
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.01em;
}

.mail-preview-toggles {
  display: flex;
  align-items: center;
  gap: 2px;
}

.mail-preview-toggles button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: #c5c9d8;
  font-size: 18px;
  cursor: pointer;
}

.mail-preview-toggles button.is-active {
  color: var(--mail-primary);
}

.mail-preview-frame {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 0 4px;
}

.mail-preview-frame.is-mobile .mail-preview-canvas {
  max-width: 320px;
  margin: 0 auto;
}

.mail-preview-canvas {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 480px;
}

.mail-preview-body {
  color: #5a6078;
  font-size: 14px;
  line-height: 1.7;
}

.mail-preview-footer {
  margin: auto 0 0;
  padding-top: 40px;
  color: #b0b4c8;
  font-size: 12px;
  line-height: 1.5;
}

@media (max-width: 1199px) {
  .mail-preview-card {
    position: static;
    min-height: 0;
  }
}

@media (max-width: 767px) {
  .mail-card {
    padding: 18px;
  }
}
</style>

<style>
.mail-template-page .mail-preview-body img,
.mail-template-page .mail-preview-body table {
  max-width: 100%;
  height: auto;
}

.mail-template-page .mail-preview-body h1,
.mail-template-page .mail-preview-body h2,
.mail-template-page .mail-preview-body h3 {
  margin: 0 0 12px;
  color: #171a2f;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.3;
}

.mail-template-page .mail-preview-body p {
  margin: 0 0 12px;
}

.mail-template-page .mail-preview-var {
  color: #5b4fff;
  font-weight: 700;
}

.mail-template-page .mail-preview-body .btn,
.mail-template-page .mail-preview-body a.btn {
  display: inline-block;
  background: #5b4fff !important;
  color: #fff !important;
  padding: 12px 28px;
  border: 0;
  border-radius: 10px;
  text-decoration: none;
  font-size: 14px;
  font-weight: 600;
}
</style>
